import { FC, ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { Paths } from 'utils/constants';
import Utils from 'utils/utils';

import { HeaderButton, LogoType, ProfileButton, Header } from 'componets/ui';

import { useTranslate } from 'hooks';

import styles from './index.module.scss';
import cn from 'classnames';

type RegistrationLayoutProps = {
	children: ReactNode;
	bottom?: ReactNode;
	email?: string;
	fromOverview?: boolean;
	customClassName?: string;
};
export const RegistrationLayout: FC<RegistrationLayoutProps> = ({
	children,
	fromOverview,
	bottom,
	email,
	customClassName,
}) => {
	const { alreadyHaveAccountText, loginText } = useTranslate([
		'alreadyHaveAccountText',
		'loginText',
	]);

	return (
		<div className={styles.root}>
			<div className={styles.content}>
				<Header email={email}>
					<>
						{fromOverview ? (
							<Link to={Paths.OVERVIEW}>
								<LogoType />
							</Link>
						) : (
							<a href={Utils.getLinkToWP('')}>
								<LogoType />
							</a>
						)}
						<div className={styles.row}>
							{email ? (
								<ProfileButton email={email} />
							) : (
								<HeaderButton text={alreadyHaveAccountText} link="/" title={loginText} />
							)}
						</div>
					</>
				</Header>

				<div className={styles.center}>
					<div className={cn(styles.box, { [`${customClassName}`]: customClassName })}>
						{children}
					</div>
				</div>
				<div className={styles.bottom}>{bottom}</div>
			</div>
		</div>
	);
};
